import Vue from 'vue'
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'QGF6GHnomNC1l8voL4wyzMNFokh2UFuY' // 在此处填写您的API密钥
})
